import React, { useRef } from 'react'

import {
  BaseContent,
  Button,
  ButtonGroup,
  Heading,
  useMediaQueryContext,
} from '@fourthwall/components'

import * as S from './UploadSuccess.styled'

type UploadSuccessProps = {
  supporterName: string
  onContinue?: () => void
  onClose?: () => void
}

const GIFS = [
  'https://cdn.fourthwall.com/mobile/superman.gif',
  'https://cdn.fourthwall.com/mobile/notbad.gif',
  'https://cdn.fourthwall.com/mobile/crazy.gif',
  'https://cdn.fourthwall.com/mobile/ohyoucreazy.gif',
  'https://cdn.fourthwall.com/mobile/awesome.gif',
  'https://cdn.fourthwall.com/mobile/wow.gif',
]

export const UploadSuccess = ({ supporterName, onContinue, onClose }: UploadSuccessProps) => {
  const media = useMediaQueryContext()
  const gifIndex = useRef(Math.floor(Math.random() * GIFS.length))

  return (
    <S.Container>
      <S.Gif src={GIFS[gifIndex.current]} />
      <S.Content>
        <Heading type="h4" weight="semibold">
          <S.Message>You just made {supporterName}’s day!</S.Message>
        </Heading>
        <BaseContent>
          <span>
            Did you know that fans that you thank are <br /> 5x more likely to come back and buy
            again?
          </span>
        </BaseContent>
      </S.Content>
      <S.Footer>
        <ButtonGroup
          space="medium"
          align="center"
          fullWidth={!media.laptop}
          direction={media.laptop ? 'row' : 'column-reverse'}
        >
          <Button fullWidth={!media.laptop} label="I’m done for today" onClick={onClose} />
          {onContinue && (
            <Button
              fullWidth={!media.laptop}
              label="Thank another supporter"
              appearance="primary"
              onClick={onContinue}
            />
          )}
        </ButtonGroup>
      </S.Footer>
    </S.Container>
  )
}
